
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"menu-action.title":"Execute drill-through","drillThrough.other.category":"Further drill-throughs"},"de":{"menu-action.title":"Drill-through ausführen","drillThrough.other.category":"Weitere Drill-throughs"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();